module.exports = __webpack_public_path__ + "94eb04cf096df59d7f84aba2f72a1e5d.png";